import React from 'react'

import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'

const withMutation = WrappedComponent => {
  return props => {
    const {
      onMutationError, // via withFormResults
      onMutationCompleted // via withFormResults
    } = props

    const [
      createCamper,
      { loading: mutationLoading, error: mutationError, data: mutationData }
    ] = useMutation(mutation, {
      onError: onMutationError,
      onCompleted: onMutationCompleted
    })

    return (
      <WrappedComponent
        mutationLoading={mutationLoading}
        mutationError={mutationError}
        mutationData={mutationData}
        createCamper={createCamper}
        {...props}
      />
    )
  }
}

export default withMutation
